<template>
    <div>
        <sub-menu-faturamento ativo="receb-nao-ident" v-if="!financeiro" />

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row"> 
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input
                            type="select"
                            icon="fa fa-building fa-fw"
                            placeholder="Unidades..."
                            :optionsList="$store.state.unidade.unidade_operacaos"
                            optionsData="id_unidade_operacao"
                            :edicao="!$store.state.user.id_unidade_operacao > 0"
                            v-model="id_unidade_operacao" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="far fa-credit-card"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: true 
                            }"
                            optionsName="operadoras-para-fatura-2"
                            placeholder="Todas as Operadoras..."
                            v-model="id_operadora">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-8">
                        <az-input
                            icon="fa fa-search"
                            v-model="search">
                            <template v-slot:buttonposb>
                                <print-export printid="impressao-posicao" :left="true" :landscape="true">
                                    <template v-slot:outros>
                                        <!-- Sintético/Analítico / :dados="dadosFormatados" -->
                                        <div class="btn-group dropleft ml-1" v-if="false">
                                            <button type="button" class="btn btn-outline-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ sintetico ? 'Sintético' : 'Analítico' }}
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" href="#" v-if="!sintetico" @click.prevent="sintetico = true">
                                                    <i class="far fa-list-alt mr-2"></i>
                                                    Exportar Sintético
                                                </a>
                                                <a class="dropdown-item" href="#" v-else @click.prevent="sintetico = false">
                                                    <i class="fas fa-list mr-2"></i>
                                                    Exportar Analítico
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                </print-export>
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
                v-if="!lista.length"
                :icon="firstLoad ? '' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhum item encontrado.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>

        <div id="impressao-posicao" v-else>

            <cabecalho-generico titulo="Recebimentos não Identificados">    
                <div>
                    Período: {{ $util.getFormatDate(dados.parms.inicio) }} a {{ $util.getFormatDate(dados.parms.fim) }}
                </div>           
            </cabecalho-generico>

            <table class="table table-hover bg-white">
                <thead>
                    <tr>
                        <th>Fatura</th>
                        <th>Operadora</th>
                        <th>Unidade</th>
                        <th>Emissão</th>
                        <th>Recebimento</th>
                        <th class="text-right">Guias</th>
                        <th class="text-right">Valor</th>
                        <th class="text-right">A Mais</th>
                        <th class="text-right">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(receb, irx) in lista" :key="irx">
                        <td>
                            <a href="#" @click.prevent="$util.abrirFatura(receb.id_fatura)" class="card-link">
                                #{{ receb.id_fatura }}
                            </a>
                        </td>
                        <td>{{ receb.st_operadora }}</td>
                        <td>{{ receb.unidades }}</td>
                        <td>{{ $util.getFormatDate(receb.dt_emissao) }}</td>
                        <td>{{ $util.getFormatDate(receb.dt_retorno) }}</td>
                        <td class="text-right">{{ receb.qtd }}</td>
                        <td class="text-right">{{ $util.formatMoeda(receb.valor) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(receb.a_mais) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(receb.valor + receb.a_mais) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th colspan="6">Total:</th>
                        <th class="text-right">{{ $util.formatMoeda(total_valor) }}</th>
                        <th class="text-right">{{ $util.formatMoeda(total_a_mais) }}</th>
                        <th class="text-right">{{ $util.formatMoeda(total_valor + total_a_mais) }}</th>
                    </tr>
                </tfoot>
            </table>

            <pre v-if="false">{{ lista }}</pre>

            <br><br><br><br><br>

        </div>

        <pre v-if="false" class="alert alert-warning">{{ dadosFormatados }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data() { 
        return { 
            dados: null, 
            inicio: "",
            fim: "", 
            id_operadora: "", 
            id_unidade_operacao: "", 
            id_recepcao: "", 
            tipo_data: "E", 
            firstLoad: false, 
            canceltoken: null, 
            periodo: "m",
            search: "", 
            filtros: { 
                periodo: "m",
                inicio: "",
                fim: "", 
                tipo_contrato: "", 
                tipo: "", 
                tipo_reembolso: "", 
                tipo_saldo: "", 
                retroativo: false, 
                dt_retroativo: null, 
            },
            sintetico: true
        }
    },

    props: ['financeiro'],

    components: { 
        SubMenuFaturamento,
        AzEmptyState, 
        AzInput, 
        PrintExport, 
        CabecalhoGenerico, 
        AzPeriodo, 
    },

    computed: { 
        total_valor: function() { 
            return this.lista.reduce((total, carry) => { 
                return total + parseFloat(carry.valor);
            }, 0);
        },

        total_a_mais: function() { 
            return this.lista.reduce((total, carry) => { 
                return total + parseFloat(carry.a_mais ? carry.a_mais : 0);
            }, 0);
        },

        lista_recepcoes: function () { 
            if ( !this.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        dadosFormatados: function () { 
            return [];

            /*
            if ( this.sintetico ) { 
                return _.map(
                    this.tabela,
                    (items, operadora) => { 
                        return {
                            operadora: operadora, 
                            faturado: this.$util.formatMoeda(this.totalizar(items, 'valor')),
                            recebido: this.$util.formatMoeda(this.totalizar(items, 'recebido')),
                            glosado: this.$util.formatMoeda(this.totalizar(items, 'glosado')),
                            em_analise: this.$util.formatMoeda(this.totalizar(items, 'em_analise')),
                            acatado: this.$util.formatMoeda(this.totalizar(items, 'acatado')),
                            recursado: this.$util.formatMoeda(this.totalizar(items, 'reapresentado')),
                            recuperada: this.$util.formatMoeda(this.totalizar(items, 'recuperado')),
                            glosado_recurso: this.$util.formatMoeda(this.totalizar(items, 'glosado_nr')), 
                            definitiva: this.$util.formatMoeda(this.totalizar(items, 'definitiva')), 
                            saldo: this.$util.formatMoeda(this.totalizar(items, 'saldo')),
                        }
                    }
                );
            } 

            if ( !this.dados || !this.dados.posicao )
                return [];

            return _.map(
                    this.dados.posicao,
                    item => { 
                        return {
                            operadora: item.st_operadora, 
                            tipo: this.dados.tipo == 'R' ? 'Recurso' : 'Fatura',
                            numero: item.id_fatura,
                            emissao: this.$util.getFormatDate(item.dt_emissao),
                            envio: this.$util.getFormatDate(item.dt_envio),
                            vencimento: this.$util.getFormatDate(item.dt_vencimento),
                            faturado: this.$util.formatMoeda(item.valor),
                            recebido: this.$util.formatMoeda(item.recebido),
                            glosado: this.$util.formatMoeda(item.glosado),
                            em_analise: this.$util.formatMoeda(item.em_analise),
                            acatado: this.$util.formatMoeda(item.acatado),
                            recursado: this.$util.formatMoeda(item.reapresentado),
                            recuperada: this.$util.formatMoeda(item.recuperado),
                            glosado_recurso: this.$util.formatMoeda(item.glosado_nr), 
                            definitiva: this.$util.formatMoeda(item.definitiva), 
                            saldo: this.$util.formatMoeda(Math.round(item.saldo * 100) / 100), 
                            unidade: item.unidades, 
                            nf: item.st_nota_fiscal, 
                        }
                    }
                );
            */
        },

        tabela: function () { 

            if ( !this.dados )
                return [];

            let lista;

            if ( this.search ) { 
                let reg = this.$util.getregex(this.search);
                lista = this.dados.posicao.filter(item => reg.test(JSON.stringify(item)));
            } else { 
                lista = this.dados.posicao;
            }

            return _.groupBy(lista, 'st_operadora');

        },

        graf_por_operadora: function () { 

            if ( !this.dados )
                return;

            
            
            let dados = _.map(this.tabela, (items, chave) => { 
                return { 
                    label: chave, 
                    valor: this.totalizar(items, 'glosado')
                };
            });

            dados = _.orderBy(dados, 'valor', 'desc');

            let data = _.slice(dados, 0, 4);
            let agrupados = _.slice(dados, 4, dados.length);

            if ( agrupados.length ) { 

                data.push({ 
                    label: 'Outros',
                    valor: agrupados.reduce((total, item) => { 
                        return total + item.valor;
                    }, 0)
                });

            }

            let labels = data.map(item => item.label);
            data = data.map(item => item.valor);

            return { 
                labels: labels,
                datasets: [
					{
						label: 'Glosa',
                        data: data,
                        backgroundColor: [
                            "#264643",
                            "#2A9D8F",
                            "#E9C46A",
                            "#F4A261",
                            "#E76F51",
                        ],
                    },
                ]
            };

        },

        graf_por_status: function () { 

            if ( !this.dados )
                return;

            let labels = ['Em Análise', 'Acatado', 'Recursado'];
            
            let dados = [
                this.totalizar(this.dados.posicao, 'em_analise'),
                this.totalizar(this.dados.posicao, 'acatado'),
                this.totalizar(this.dados.posicao, 'reapresentado'),
            ]
            
            return { 
                labels: labels,
                datasets: [
					{
						label: 'Glosa',
                        data: dados,
                        backgroundColor: [
                            "#264643",
                            "#2A9D8F",
                            "#E9C46A",
                            "#F4A261",
                            "#E76F51",
                        ],
                    },
                ]
            };

        },

        lista: function () { 
            if ( !this.dados || !this.dados.lista ) { 
                return [];
            }

            let reg = this.$util.getregex(this.search);

            return this.dados.lista.filter(item => { 
                return ( !this.search || reg.test(JSON.stringify(item)) );  
            });
        }
    },

    methods: { 
        formatMoedaGrafico(value) { 
            let show = this.$util.formatMoeda(value);
            return show.substr(0,show.length - 3);
        },

        faturas (lista) { 
            return _.groupBy(lista, 'id_fatura');
        },

        percentual (total, parte) { 
            if ( total )
                return Math.round( ( parte / total ) * 100 ) + '%';
        },
        totalizar (items, campo) { 
            if ( !items )
                return 0;

            return items.filter(item => item[campo])
                .reduce((total, item) => total + parseFloat(item[campo]), 0);
        },

        load() { 

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            $('.collapse').collapse('hide');

            /*
            inicio: this.inicio,
            fim: this.fim,
            periodo: this.periodo,
            */

            this.$util.load(this, { 
                service: 'faturas',
                func: 'receb_nao_ident',
                redir_api: true, 
                parms: { 
                    tipo_data: this.tipo_data,
                    id_operadora: this.id_operadora,
                    id_unidade_operacao: this.id_unidade_operacao,
                    id_recepcao: this.id_recepcao, 
                    ...this.filtros,
                },
                canceltoken: this.canceltoken.token,
                loadTo: res => { 
                    this.firstLoad = true;
                    this.dados = res;
                }
            });
        },

        ajustar_fim() { 
            if ( !this.firstLoad )
                return;

            if ( this.inicio )
                this.fim = this.inicio;
        },
    },

    beforeMount () { 

        this.inicio = moment().subtract(30, "days").format('YYYY-MM-DD');
        this.fim = moment().format('YYYY-MM-DD');

    },

    mounted() { 
        //this.load();
        //this.firstLoad = true;
        
        if ( this.financeiro ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Financeiro", path: "/financeiro/lancamento" },
                { name: "Recebimentos não Identificados", path: "/financeiro/receb-nao-ident" }
            ]);
        } else { 
            this.$store.commit('setBreadcrumb', 
                [
                    { name: "Faturamento", path: "/faturamento/visao"},
                    { name: "Recebimentos não Identificados", path: "/financeiro/receb-nao-ident" }
                ]
            );
        }
    }
}
</script>